// extracted by mini-css-extract-plugin
export default {"container":"_3evk","inner_container":"_3GEC","loop_container":"_2ifB","loop_link":"el3s","email_container":"BoK6"};